import { pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import type { ComponentStyleType } from "@/lib/types/flow";
import { T } from "./settings-style-form.i18n";

type SettingsStyleFormProps = {
  flowLanguage: string;
  style: ComponentStyleType;
  onStyleChange: (style: ComponentStyleType) => void;
  title: string;
  onTitleChange: (title: string) => void;
  description: string;
  onDescriptionChange: (description: string) => void;
};

export function SettingsStyleForm({
  flowLanguage,
  style,
  onStyleChange,
  title,
  onTitleChange,
  description,
  onDescriptionChange,
}: SettingsStyleFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="component-style">{t.style}</Label>
        <Select value={style} onValueChange={(v) => onStyleChange(v as ComponentStyleType)}>
          <SelectTrigger id="component-style">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">{t.styleNone}</SelectItem>
            <SelectItem value="border">{t.styleBorder}</SelectItem>
            <SelectItem value="box">{t.styleBox}</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">{t.styleHelp}</p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="component-title">{t.titleOptional}</Label>
        <Input
          id="component-title"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          placeholder={t.titlePlaceholder}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="component-description">{t.descriptionOptional}</Label>
        <Textarea
          id="component-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder={t.descriptionPlaceholder}
          rows={3}
        />
      </div>
    </div>
  );
}
